<template>
  <div class="">
    <router-link
      class="mr-3 btn btn-info"
      :to="{
        path: `/Region/service/transactions/${data.companyServiceId}`,
        query: {
          serviceName: data.companyService,
          serviceId: data.id,
          branchId: $route.query.branchId,
          companyId: $route.query.companyId,
          regionId: $route.query.regionId,
        },
      }"
    >
       {{$t('text.clickButtons.transactionHistory')}}
    </router-link>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {},
  methods: {},
};
</script>
